// 頁首範圍切換器 ↔ 左側組織樹同步（SPEC #org-tree-ui 第 1 點「跟頁首範圍是同一個狀態」，VMS UX 評審 2026-10-13 P0-3）：
// 範圍本身在 lib/scope.tsx（兩邊讀寫同一個）；這裡只傳「左樹要展開哪幾層」——從頁首選了組織樹的節點時，左樹不知道它的上層是誰。
type Listener = (keys: string[]) => void;
const listeners = new Set<Listener>();
let pending: string[] = [];

/** 請左樹展開這些 key（路徑上每一層）；左樹還沒畫出來時先記著，畫出來再取。 */
export function requestTreeReveal(keys: string[]): void {
  pending = keys;
  listeners.forEach((l) => l(keys));
}

export function onTreeReveal(l: Listener): () => void {
  listeners.add(l);
  return () => listeners.delete(l);
}

export function takePendingReveal(): string[] {
  const k = pending;
  pending = [];
  return k;
}
